export function getModifierKey(): string {
  return navigator.platform.toUpperCase().includes('MAC') ? '⌘' : 'Ctrl'
}
